/* eslint-disable quotes */
/* eslint-disable camelcase */
import _ from 'lodash';
import moment, { Moment } from 'moment';
import { formatPhone, getPromotion } from './customer';
import { getFirebaseCustomerId } from '../api/firebase/firebaseAuthentication';
import store from '../redux/store';
import {
  API_SEND_ORDER,
  OPTION_CATEGORY_TYPE,
  Basket,
  DELIVERY_FLEET_CONFIGURATION_TYPE,
  MENU_ELEMENT_MEASUREMENT_UNIT,
  Option,
  OptionList,
  ORDER_FLOW_TYPE,
  ORDER_PHASE,
  ORDER_PHASE_CONTACTING,
  ORDER_PHASE_DELIVERING,
  ORDER_PHASE_DELIVERING_TIME,
  ORDER_PHASE_PREPARING,
  ORDER_PHASE_PREPARING_TIME,
  ORDER_PHASE_TAKEAWAY,
  ORDER_PHASE_WAITER,
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_CLICK_AND_COLLECT_LABEL,
  ORDER_TYPE_CLICK_AND_SEAT,
  ORDER_TYPE_CLICK_AND_SEAT_LABEL,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_DELIVERY_LABEL,
  PAYMENT,
  PICKUP_STATUS,
  Product,
} from '../constants';
import {
  DEFAULT_SEND_ORDER_ERROR,
  getCustomerTableNb,
  getRestFutureDays,
  getTimezone,
  isObjectNotNull,
  isStringNotNull,
  removeUndefined,
} from '.';
import { isQrCode } from './config';
import { showCartModal, showMessageModal, showOrderModal, showOrderStatus, } from '../redux/actions';
import {
  addCardToExistingCustomer,
  confirmPaymentIntent,
  createCustomer,
  createPayment,
  deleteCustomerPaymentCardBackend,
  refundCustomerPaymentIntent,
  retrieveCard,
  sendGoogleAnalytics,
  sendPostRequest,
  updateCustomerHubrise,
  updateUser,
} from '../api';
import { getClosedMessage } from './shop';
import { analyticsEvents } from './firebaseAnalytics';
import {
  ensureBoolean,
  ensureInteger,
  ensureNumber,
  ensureString,
  ensureStringOrNumber,
} from './common';
import { logHighError, logLowLog, logMediumError } from './logger';


export const roundNumber = (number) => {
  return Math.round(number * 100) / 100;
};

export const checkClosedShop = (setLoading) => {
  const { closed } = store.getState().shopReducer;
  if (isStringNotNull(closed)) {
    setLoading(false);
    store.dispatch(showMessageModal(getClosedMessage(closed)));
    return true;
  }
  return false;
};
export const showMessageModalWithLoading = (setLoading, message) => {
  setLoading(false);
  store.dispatch(showMessageModal(message));
};

export const attachPaymentMethodToCustomer = async (card) => {
  const { user, userConnected } = store.getState().userReducer;
  const { id } = card;
  const customerId = getFirebaseCustomerId();
  try {
    const { stripeCustomerId, email } = user;
    const data = {
      cardId: id,
      customerId,
    };
    const cardOnStripe = await retrieveCard(data);
    if (!cardOnStripe || !cardOnStripe.customer) {
      const data = { card, customerId };
      logLowLog('Ading card to customer');
      if (stripeCustomerId) {
        data['stripeCustomerId'] = stripeCustomerId;
        await addCardToExistingCustomer(data);
      } else {
        data['email'] = email;
        await createCustomer(data);
      }
    }
    logLowLog('Successfully creating payment intent');
    return true;
  } catch (error) {
    const errorMessage = String(error);
    if (!errorMessage.includes('not be used again')) {
      logMediumError(`Could not attach payment method to customer ${error}`);
    } else if (userConnected) {
      deleteCustomerPaymentCardBackend(id);
    }
    throw error;
  }
};

export const sendOrderClick = async ({
  paymentType,
  card,
  stripe,
  setLoading,
  phoneObj,
  setChoosePayment,
}) => {
  let chargeId = null
  const { user, userConnected } = store.getState().userReducer;
  const { email, stripeCustomerId, customerId } = user;
  try {
    logLowLog('Sending new order');
    const { servicePrice } = store.getState().shopReducer;
    const { orderTime } = store.getState().orderReducer;
    const { configHours } = store.getState().configurationReducer;
    const { customAccountId } = servicePrice;
    const {
      shopId,
      orderType,
      totalProductPriceOrder,
      totalPriceOrder,
      address: customerAddress,
    } = store.getState().pendingOrderReducer;
    const finalOrder = {};
    const promotion = getPromotion(totalProductPriceOrder);
    finalOrder['paymentType'] = paymentType;
    finalOrder['timezone'] = getTimezone();
    finalOrder['canal'] = isQrCode() ? 'QRCODE' : 'WEBAPP';
    if (orderType === ORDER_TYPE_DELIVERY) {
      finalOrder['instruction'] = customerAddress?.instruction
      finalOrder['street2'] = customerAddress?.street2
    }
    if (orderType === ORDER_TYPE_CLICK_AND_SEAT && isQrCode()) {
      finalOrder['tableNb'] = getCustomerTableNb();
    }
    finalOrder['date'] = configHours.hideScheduledTime
      ? moment().format()
      : orderTime.data.format();
    if (promotion && !promotion.minBasketPrice) {
      finalOrder['promotion'] = promotion;
    }
    if (userConnected) {
      const numero = formatPhone(user.numero);
      await updateCustomerHubrise(
        { address: customerAddress, numero },
        customerId
      );
      await updateUser(customerId, {
        numero: numero || '',
        phone: phoneObj,
      });
    }

    if (paymentType === PAYMENT.TYPE_STRIPE && totalPriceOrder) {
      try {
        logLowLog('Creating payment');
        const amount = Math.round(totalPriceOrder * 100);
        const transferGroup = moment.utc(finalOrder['date']).format('X');
        const intentData = {
          amount,
          description: `${shopId} - ${email}`,
          currency: 'eur',
          customer: stripeCustomerId,
          capture_method: 'manual',
          confirmation_method: 'manual',
          payment_method: card.id,
          confirm: true,
          setup_future_usage: 'on_session',
          on_behalf_of: customAccountId,
          transfer_data: {
            destination: customAccountId,
          },
          transfer_group: transferGroup,
        };
        const data = { intentData, shopId, customerId };
        const charge = await createPayment(data);
        const { id, status, client_secret } = charge;
        finalOrder['chargeId'] = id;
        chargeId = id
        if (userConnected) {
          attachPaymentMethodToCustomer(card);
        }
        if (status === 'requires_source_action') {
          logLowLog(`Requiring confirmation for payment ${id}`);

          const { error, paymentIntent } = await stripe.handleCardAction(
            client_secret
          );

          logLowLog(`Success confirmation for payment ${id}`);

          if (error) {
            logHighError(JSON.stringify(error));
            throw error;
          } else if (paymentIntent.status === 'requires_confirmation') {
            logLowLog(`Asking for 3D SECURE ${id}`);
            await confirmPaymentIntent(paymentIntent.id, customerId);
            logLowLog(`Successfully verifying with 3D SECURE ${id}`);
          }
        }
      } catch (error) {
        const errorMessage = String(error);
        if (userConnected) {
          attachPaymentMethodToCustomer(card);
        }
        if (
          !errorMessage.includes('insufficient') &&
          !errorMessage.includes('declined') &&
          !errorMessage.includes('support') &&
          !errorMessage.includes('incorrect') &&
          !errorMessage.includes('A network')
        ) {
          logHighError(`Custom authorization failed ${JSON.stringify(error)}`);
        }
        store.dispatch(
          showMessageModal(
            'Le paiement en ligne a échoué. Veuillez réessayer ou changer de carte bancaire.'
          )
        );
        setLoading(false);
        return;
      }
    }
    logLowLog(`Sending order to firebase ${JSON.stringify(finalOrder)}`);
    await sendOrder({
      customerId,
      setLoading,
      order: finalOrder,
      setChoosePayment,
    });
  } catch (error) {
    const errorMessage = String(error ?? DEFAULT_SEND_ORDER_ERROR);
    logHighError(`An error occured while sending order ${errorMessage}`);
    if (paymentType === PAYMENT.TYPE_STRIPE && chargeId) {
      logHighError(`Need to refund the order paymentIntent due to an error that occurred while sending the order with chargeId ${chargeId}. \n ${JSON.stringify(error)}`);
      //refundCustomerPaymentIntent(customerId, chargeId)
    }
    setLoading(false);
    setChoosePayment(false);
    store.dispatch(showMessageModal(errorMessage));
  }
};

export const checkIfOrderIsInActivationRange = ({
  sections,
  commande,
  day,
}) => {
  const sectionsToCheck = [];
  _.map(commande, (product) => {
    const sectionProduct = _.find(
      _.cloneDeep(sections),
      (section) => section.key === product.sectionKey
    );
    if (sectionProduct?.activationRange) sectionsToCheck.push(sectionProduct);
  });
  return isOrderInActivationRange(sectionsToCheck, day);
};

export const isOrderInActivationRange = (sections, selectedDay) => {
  if (!sections.length) return true;
  let availableDays = sections[0]?.activationRange?.daysOfWeek;
  let currentEndDate = moment(sections[0]?.activationRange?.endDate).format();
  const daysOfWeekSlots = {};
  _.map(sections, (section) => {
    const { activationRange } = section;
    const formattedEndDate = moment(activationRange?.endDate).format();
    availableDays = getAvailableDays(
      availableDays,
      activationRange.daysOfWeek,
      daysOfWeekSlots
    );
    if (moment(formattedEndDate).isSameOrBefore(moment(currentEndDate))) {
      currentEndDate = formattedEndDate;
    }
  });
  return checkAllDatesInActivationRange(
    currentEndDate,
    availableDays,
    selectedDay
  );
};

const getCommonSlots = (slots1, slots2) => {
  const result = [];

  const parseSlot = (slot) =>
    slot.split('-').map((time) => moment(time, 'HH:mm'));
  const formatSlot = (start, end) =>
    `${start.format('HH:mm')}-${end.format('HH:mm')}`;
  let i = 0,
    j = 0;
  while (i < slots1.length && j < slots2.length) {
    const [start1M, end1M] = parseSlot(slots1[i]);
    const [start2M, end2M] = parseSlot(slots2[j]);

    if (end1M.isSameOrBefore(start2M)) {
      i++;
    } else if (end2M.isSameOrBefore(start1M)) {
      j++;
    } else {
      const startMax = moment.max(start1M, start2M);
      const endMin = moment.min(end1M, end2M);
      result.push(formatSlot(startMax, endMin));

      if (end1M.isBefore(end2M)) {
        i++;
      } else {
        j++;
      }
    }
  }
  return mergeSlots(result, parseSlot, formatSlot);
};

const mergeSlots = (slots, parseSlot, formatSlot) => {
  const mergedResult = [];

  _.forEach(slots, (slot) => {
    const [start, end] = parseSlot(slot);

    if (_.isEmpty(mergedResult)) {
      mergedResult.push(slot);
    } else {
      const [lastStart, lastEnd] = parseSlot(_.last(mergedResult));
      if (lastEnd.isSame(start) || lastEnd.add(1, 'minute').isSame(start)) {
        const newEnd = moment.max(lastEnd, end);
        mergedResult[mergedResult.length - 1] = formatSlot(lastStart, newEnd);
      } else {
        mergedResult.push(slot);
      }
    }
  });
  return mergedResult;
};

const getAvailableDays = (
  availableDays,
  sectionDaysOfWeek,
  daysOfWeekSlots
) => {
  _.forEach(sectionDaysOfWeek, (section, key) => {
    if (!_.isEmpty(section.slots)) {
      daysOfWeekSlots[key] = daysOfWeekSlots[key]
        ? getCommonSlots(daysOfWeekSlots[key], section.slots)
        : section.slots;
    }
  });
  return _.pickBy(availableDays, (day, key) => {
    if (sectionDaysOfWeek[key]) {
      if (!_.isEmpty(daysOfWeekSlots?.[key])) {
        availableDays[key].slots = daysOfWeekSlots[key];
        availableDays[key].fullDay = false;
      }
      return true;
    }
    return false;
  });
};

const checkAllDatesInActivationRange = (
  endDate,
  availableDays,
  selectedDay
) => {
  const { orderTime } = store.getState().orderReducer;
  const selectedHour = orderTime.value.split('-')[0];
  const allAvailableDates = [];
  const now = moment();
  while (now.isBefore(endDate)) {
    const currentDay = now.format('dddd');
    const dayConfig = availableDays[currentDay];
    if (dayConfig) {
      const slots = dayConfig.fullDay ? ['00:00-23:59'] : dayConfig.slots;
      allAvailableDates.push({
        day: moment(now).format('DD/MM/YYYY'),
        dayOfWeek: currentDay,
        slots,
      });
    }
    now.add(1, 'days');
  }
  const dayOfWeekSelected = moment(selectedDay).format('dddd');
  let isHourValid = false;
  const isDayAvailable = _.find(allAvailableDates, (date) => {
    if (date.dayOfWeek === dayOfWeekSelected) {
      isHourValid = _.some(date.slots, (slot) => {
        const [startSlot, endSlot] = slot.split('-');
        return selectedHour >= startSlot && selectedHour <= endSlot;
      });
    }
    return date.day === moment(selectedDay).format('DD/MM/YYYY') && isHourValid;
  });

  return !isDayAvailable && getRestFutureDays(allAvailableDates);
};

export const sendOrder = async ({
  customerId,
  setLoading,
  order,
  setChoosePayment,
}) => {
  const {
    orderType,
    address,
    totalPriceOrder,
    managementFee,
    commande = null,
  } = store.getState().pendingOrderReducer;
  const userServicePrice = address.deliveryPrice;
  const { date, promotion, paymentType } = order;
  if (isObjectNotNull(commande)) {
    logLowLog(
      `DISHOP WEBAPP - A new order has been sent.\n ${JSON.stringify(order)}`
    );
    const { companyId } = store.getState().configurationReducer;
    await sendPostRequest(API_SEND_ORDER(companyId, customerId), order, false);
  } else {
    showMessageModalWithLoading(
      setLoading,
      "Votre commande n'a pas pu être envoyée, car votre panier ne contenait aucun produit."
    );
    store.dispatch(showCartModal(false));
    logHighError(
      `Error in shop ${order.shopId}. Basket was empty when sending order for user ${order.id}.`
    );
    return;
  }
  store.dispatch(showCartModal(false));
  store.dispatch(showOrderModal(true));
  store.dispatch(showOrderStatus(order.chargeId));
  setLoading(false);
  setChoosePayment(false);
  const items = [];
  _.map(commande, (product) => {
    const { key, name, sectionName, nb, price, position } = product;
    items.push({
      id: key,
      name,
      category: sectionName,
      position,
      quantity: nb,
      price,
    });
  });
  const promoCode = promotion?.promoCode ?? '';
  const day = moment(date).format('dddd');
  const hour = moment(date).format('HH:mm');
  const analyticsData = {
    coupon: promoCode,
    currency: 'EUR',
    shipping: userServicePrice,
    tax: managementFee,
    value: totalPriceOrder,
    items,
  };
  sendGoogleAnalytics('purchase', analyticsData);
  analyticsEvents.logPurchase(
    promoCode,
    userServicePrice,
    managementFee,
    paymentType,
    totalPriceOrder,
    orderType,
    address?.city,
    day,
    hour,
    order.isSchedule
  );
};

export const getEstimationTime = (order) => {
  const {
    orderType,
    status,
    isSchedule,
    expectedDropoffDate = null,
    date: dateOrder,
    dateSent = moment(),
    datePreparationStarted = moment(),
    datePreparationEnded = moment(),
  } = order;
  if (expectedDropoffDate) {
    return moment(expectedDropoffDate)
  }
  let date = moment(dateOrder);
  switch (status) {
    case ORDER_PHASE_CONTACTING: {
      if (!isSchedule) {
        let defaultMinutesTimeToAdd = ORDER_PHASE_PREPARING_TIME;
        if (orderType === ORDER_TYPE_DELIVERY) {
          defaultMinutesTimeToAdd += ORDER_PHASE_DELIVERING_TIME;
        }
        date = moment(dateSent).add(defaultMinutesTimeToAdd, 'm');
      }
      return date
    }
    case ORDER_PHASE_PREPARING: {
      const { preparationTime, isSchedule } = order;
      let defaultMinutesTimeToAdd = preparationTime;
      if (isSchedule) {
        date = date.add(defaultMinutesTimeToAdd, 'm');
      }
      if (orderType === ORDER_TYPE_DELIVERY) {
        defaultMinutesTimeToAdd += ORDER_PHASE_DELIVERING_TIME;
      }
      let estimationTime = moment(datePreparationStarted).add(
        defaultMinutesTimeToAdd,
        'm'
      );
      if (estimationTime.isBefore(date)) {
        estimationTime = date;
      }
      return estimationTime;
    }
    case ORDER_PHASE_DELIVERING: {
      let estimationTime = moment(datePreparationEnded).add(
        ORDER_PHASE_DELIVERING_TIME,
        'm'
      );
      if (estimationTime.isBefore(date)) {
        estimationTime = date;
      }
      return estimationTime;
    }
    case ORDER_PHASE_WAITER:
    case ORDER_PHASE_TAKEAWAY: {
      return moment(datePreparationEnded);
    }
    default:
      return null;
  }
};

export const getStatus = (order) => {
  if (_.isEmpty(order)) return '';
  const {
    status,
    orderFlowType = ORDER_FLOW_TYPE.CLASSIC,
    pickupStatus,
    userNameDep,
    orderType,
    tableNb,
    delivery = {},
  } = order;

  switch (status) {
    case ORDER_PHASE.CONTACTING:
      return handleContacting(
        pickupStatus,
        userNameDep,
        orderType,
        orderFlowType,
        delivery
      );
    case ORDER_PHASE.PREPARING:
      return handlePreparing(pickupStatus, userNameDep, orderType);
    case ORDER_PHASE.DELIVERING:
      return userNameDep &&
        delivery?.nature !== DELIVERY_FLEET_CONFIGURATION_TYPE.DELIVEROO
        ? `${userNameDep} se dirige vers vous`
        : `Votre commande est en cours de livraison` +
        ', plus que quelques instants avant de déguster votre plat.';
    case ORDER_PHASE.TAKEAWAY:
      return `La commande est prête. Venez vite la chercher avant qu’elle ne refroidisse.`;
    case ORDER_PHASE.WAITER:
      return `Votre serveur arrive avec votre commande${tableNb ? ` à la table ${tableNb}` : ''
        }.`;
    default:
      return '';
  }
};

const handleContacting = (
  pickupStatus,
  userNameDep,
  orderType,
  orderFlowType,
  delivery
) => {
  if (
    orderFlowType === ORDER_FLOW_TYPE.REVERSE &&
    orderType === ORDER_TYPE_DELIVERY
  ) {
    return pickupStatus === PICKUP_STATUS.ORDER_NOT_CURRENTLY_SUPPORTED
      ? delivery?.searchDriver
        ? 'Nous cherchons actuellement un livreur partenaire avant de contacter votre restaurant préféré.'
        : `Nous avons bien reçu votre commande. La recherche d'un partenaire de livraison commencera 30 minutes avant l'heure de livraison souhaitée.`
      : `Le restaurateur a bien reçu votre commande. Nous attendons sa validation. ${userNameDep ? `${userNameDep} sera votre livreur.` : ''
      }`;
  }
  return 'Le restaurateur a bien reçu votre commande. Nous attendons sa validation.';
};

const handlePreparing = (pickupStatus, userNameDep, orderType) => {
  if (orderType === ORDER_TYPE_CLICK_AND_COLLECT) {
    return 'Votre commande est en cours de préparation, vous pourrez la récupérer d’ici peu.';
  } else if (orderType === ORDER_TYPE_CLICK_AND_SEAT) {
    return 'Votre commande est en cours de préparation et sera servie sous peu.';
  }
  switch (pickupStatus) {
    case PICKUP_STATUS.ORDER_NOT_CURRENTLY_SUPPORTED:
      return 'Votre commande est en cours de préparation, elle partira en livraison d’ici peu.';
    case PICKUP_STATUS.DRIVER_ON_THE_WAY_TO_RESTAURANT:
      return `Votre commande est en cours de préparation, votre livreur ${userNameDep} se dirige vers le restaurant.`;
    default:
      return 'Votre commande est en cours de préparation.';
  }
};

export const checkOrdersLimit = (limit, beginHours, endHours) => {
  const { shopOrders } = store.getState().shopReducer;
  let nbOrdersInterval = 0;
  if (limit >= 0) {
    _.map(shopOrders, (order) => {
      let { date } = order;
      date = moment(date);
      if (
        date.isBefore(endHours, 'minutes') &&
        date.isSameOrAfter(beginHours, 'minutes')
      ) {
        nbOrdersInterval++;
      }
    });
    return nbOrdersInterval >= limit;
  }
  return false;
};

export const getOrderTypeLabel = (orderType: string) => {
  return orderType === ORDER_TYPE_DELIVERY
    ? ORDER_TYPE_DELIVERY_LABEL
    : orderType === ORDER_TYPE_CLICK_AND_COLLECT
      ? ORDER_TYPE_CLICK_AND_COLLECT_LABEL
      : ORDER_TYPE_CLICK_AND_SEAT_LABEL;
};

const emptyNullArray = ['', null];

const formatOption = (option: any): Option => {
  return {
    additional: ensureBoolean(option.additional),
    key: ensureString(option.key, false), // TODO Default
    label: ensureString(option.label, false), // TODO Default
    name: ensureString(option.name, false), // TODO Default
    nb: ensureInteger(option.nb),
    position: ensureInteger(option.position, [], 0),
    price: ensureNumber(option.price), // TODO Default
    priceRef: ensureNumber(option.priceRef, emptyNullArray),
    itemRecursiveKey: ensureString(option.itemRecursiveKey), // TODO Default
    categoryKey: ensureString(option.categoryKey), // TODO Default
    productKey: ensureString(option.productKey, true, emptyNullArray),
    ref: ensureString(option.ref, true, emptyNullArray),
    subcategories: ensureString(option.subcategories, true, emptyNullArray),
    sectionKey: ensureString(option.sectionKey, true, emptyNullArray),
    type: ensureString(option.type),
    value: ensureNumber(option.value), // TODO Default
    isFree: ensureBoolean(option.isFree),
    cashRegisterSubcategoriesHistory: Array.isArray(
      option.cashRegisterSubcategoriesHistory
    )
      ? (_.filter(
        _.map(
          option.cashRegisterSubcategoriesHistory,
          (cashRegisterSubcategoriesHistory) =>
            ensureString(cashRegisterSubcategoriesHistory, false) // TODO Default
        ),
        (cashRegisterSubcategoriesHistory) =>
          !!cashRegisterSubcategoriesHistory
      ) as string[])
      : undefined,
  };
};

const formatOptionList = (optionList: any): OptionList => {
  let options = null;
  if (!optionList) {
    return undefined;
  }
  if (typeof optionList?.options === 'object') {
    const formattedOptions = {};

    for (const optionKey of Object.keys(optionList.options)) {
      formattedOptions[optionKey] = formatOption(optionList.options[optionKey]);
    }
    options = formattedOptions;
  }
  return removeUndefined({
    categoryKey: ensureString(optionList.categoryKey, false), //TODO Default
    categoryId: ensureString(optionList.categoryId, true, emptyNullArray),
    categoryMultiple: ensureBoolean(
      optionList.categoryMultiple,
      emptyNullArray
    ),
    categoryName: ensureString(optionList.categoryName, true, emptyNullArray),
    categoryPosition: ensureInteger(
      optionList.categoryPosition,
      emptyNullArray
    ),
    categoryType: ensureString(optionList.categoryType, true, emptyNullArray),
    ref: ensureString(optionList.ref, true, emptyNullArray),
    options,
  });
};

const formatProduct = (product: any): Product => {
  return removeUndefined({
    isLoyaltyProduct: ensureBoolean(
      product.isLoyaltyProduct,
      emptyNullArray,
      null
    ),
    points: ensureNumber(product.points, emptyNullArray, null),
    boughtPrice: ensureNumber(product.boughtPrice, emptyNullArray, null),
    categories: ensureString(product.categories, false, [null], null),
    description: ensureString(product.description, true, emptyNullArray),
    disabled: ensureBoolean(product.disabled, emptyNullArray),
    disabledCC: ensureBoolean(product.disabledCC, emptyNullArray),
    disabledCS: ensureBoolean(product.disabledCS, emptyNullArray),
    disabledDelivery: ensureBoolean(product.disabledDelivery, emptyNullArray),
    instruction: ensureString(product.instruction, true, emptyNullArray),
    height: ensureNumber(product.height, emptyNullArray),
    image: ensureString(
      product.image,

      true,
      emptyNullArray
    ),
    items: Array.isArray(product.items)
      ? _.map(product.items, (item) => formatOptionList(item))
      : undefined,
    key: ensureString(product.key, false),
    logo: ensureString(product.logo, true, emptyNullArray),
    name: ensureString(product.name, true, emptyNullArray),
    type: ensureString(product.type, true, emptyNullArray),
    nb: ensureInteger(product.nb, [], 0),
    position: ensureNumber(product.position, emptyNullArray, 0),
    preparationTime: ensureStringOrNumber(product.preparationTime, true, [
      null,
    ]),
    price: ensureNumber(product.price), // TODO Default ?
    priceRef: ensureNumber(product.priceRef, emptyNullArray),
    productKey: ensureString(product.productKey, false, [null]),
    ref: ensureString(product.ref, true, emptyNullArray),
    sectionKey: ensureString(product.sectionKey, true, emptyNullArray),
    sectionName: ensureString(product.sectionName, true, emptyNullArray),
    shopId: ensureString(product.shopId),
    unit:
      product.unit === null ||
        Object.values(MENU_ELEMENT_MEASUREMENT_UNIT).includes(product.unit)
        ? product.unit
        : undefined,
    unitPrice: ensureNumber(product.unitPrice), // TODO Default ?
    width: ensureNumber(product.width, emptyNullArray),
    productPromotionCode: ensureString(
      product.productPromotionCode,
      true,
      emptyNullArray
    ),
    volume: ensureString(product.volume),
    stock: ensureNumber(product.stock),
  });
};

export const formatBasket = (basket: any): Basket => {
  const formattedBasket = {};

  for (const productId of Object.keys(basket)) {
    formattedBasket[productId] = formatProduct(basket[productId]);
  }

  return formattedBasket;
};

export const isCategoryOptionProductType = (element) => {
  return element?.type === OPTION_CATEGORY_TYPE.PRODUCT;
};
